let localStorageBackup: any = {};

export function setInStorage(key: string, value: any) {
  return function (value: any, storeInLocalStorage = true) {
    try {
      storeInLocalStorage && localStorage.setItem(key, value);
    } catch (e) {}
    localStorageBackup[key] = value;
  };
}

export function getFromStorage(key: string) {
  try {
    if (localStorageBackup[key]) {
      return localStorageBackup[key];
    }
    return localStorage.getItem(key);
  } catch (e) {}
}

export function clearStorage() {
  try {
    localStorage.clear();
  } catch (e) {}
  localStorageBackup = {};
}

export function removeFromStorage(key: string) {
  try {
    localStorage.removeItem(key);
  } catch (e) {}
  localStorageBackup[key] = null;
}
